import { bootstrap } from '@app/bootstrap'
import { App } from '@app/index'
import * as React from 'react'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom'
import * as ReactDOMClient from 'react-dom/client'
import { createRoot } from 'react-dom/client'
import * as ReactJsxRuntime from 'react/jsx-runtime'

import './index.css'

// Экспортируем React/ReactDOM в window для динамически загружаемых плагинов.
// Плагины собираются без React (external), и esbuild-shim в deploy-plugin.ts подменяет
// импорты 'react' / 'react/jsx-runtime' / 'react-dom' на модули, читающие эти глобалы.
// Это гарантирует единый экземпляр React (иначе hooks ломаются).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).__pulsyraReact = React
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).__pulsyraReactJsxRuntime = ReactJsxRuntime
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).__pulsyraReactDOM = { ...ReactDOM, ...ReactDOMClient }

if (import.meta.env.DEV) {
  document.documentElement.setAttribute('data-dev', '')
}

// Регистрируем все плагины эффектов до рендера приложения
bootstrap()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
)
